/**
 * 火花系统本地缓存
 * 实现秒开体验
 */

import { safeJsonParse } from './sanitize';

const SPARK_CACHE_KEY = 'psp_flash_ideas_cache';
const SPARK_CACHE_TIMESTAMP_KEY = 'psp_flash_ideas_timestamp';

export interface Spark {
  id: string;
  title: string;
  description?: string;
  status: 'captured' | 'thinking' | 'experimenting' | 'archived';
  project_tag: string;
  creator_comment?: string;
  created_at: string;
  updated_at: string;
}

/**
 * 从本地缓存获取火花数据
 */
export function getSparksFromCache(): Spark[] | null {
  try {
    const cacheJson = localStorage.getItem(SPARK_CACHE_KEY);
    if (!cacheJson) {
      return null;
    }

    const timestamp = localStorage.getItem(SPARK_CACHE_TIMESTAMP_KEY);
    if (timestamp) {
      const age = Date.now() - parseInt(timestamp);
    }

    const sparks: Spark[] = safeJsonParse(cacheJson, []);
    return sparks;
  } catch (error) {
    console.error('❌ [Spark Cache] 读取失败:', error);
    return null;
  }
}

/**
 * 保存火花数据到本地缓存
 */
export function saveSparksToCache(sparks: Spark[]): void {
  try {
    localStorage.setItem(SPARK_CACHE_KEY, JSON.stringify(sparks));
    localStorage.setItem(SPARK_CACHE_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    console.error('❌ [Spark Cache] 保存失败:', error);
  }
}

/**
 * 更新缓存中的单个火花
 */
export function updateSparkInCache(updatedSpark: Spark): void {
  try {
    const sparks = getSparksFromCache();
    if (sparks) {
      const index = sparks.findIndex(s => s.id === updatedSpark.id);
      if (index !== -1) {
        sparks[index] = updatedSpark;
        saveSparksToCache(sparks);
      }
    }
  } catch (error) {
    console.error('❌ [Spark Cache] 更新失败:', error);
  }
}

/**
 * 从缓存中删除火花
 */
export function deleteSparkFromCache(sparkId: string): void {
  try {
    const sparks = getSparksFromCache();
    if (sparks) {
      const newSparks = sparks.filter(s => s.id !== sparkId);
      saveSparksToCache(newSparks);
    }
  } catch (error) {
    console.error('❌ [Spark Cache] 删除失败:', error);
  }
}

/**
 * 添加新火花到缓存
 */
export function addSparkToCache(newSpark: Spark): void {
  try {
    const sparks = getSparksFromCache() || [];
    sparks.unshift(newSpark); // 添加到开头
    saveSparksToCache(sparks);
  } catch (error) {
    console.error('❌ [Spark Cache] 添加失败:', error);
  }
}

/**
 * 清除缓存
 */
export function clearSparkCache(): void {
  localStorage.removeItem(SPARK_CACHE_KEY);
  localStorage.removeItem(SPARK_CACHE_TIMESTAMP_KEY);
}
